import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observer } from 'mobx-react-lite';
import moment from 'moment';
import { ReactElement, useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import { NavigationButton } from '../../buttons/NavigationButton';
import { IDatePickerProps } from '../DayPicker';

interface IWeekPickerProps extends IDatePickerProps {
  selectedEndDate: Date;
}

export const WeekPicker = observer((props: IWeekPickerProps): ReactElement => {
  const selectedStartDate = props.selectedDate;
  const { selectedEndDate, onSetDate, onClickNext, onClickPrevious, minDate, maxDate, canClickNext, canClickPrevious } = props;
  const [isOpen, setIsOpen] = useState(false);

  const toggle = (): void => {
    setIsOpen((prevState) => !prevState);
  };

  const onChange = async (date: Date | null): Promise<void> => {
    if (date) {
      await onSetDate(moment(date).startOf('isoWeek').toDate());
      toggle();
    }
  };

  const renderLabel = (): ReactElement => (
    <div
      className='date-label-container'
      onClick={toggle}
    >
      <div>
        <label
          className='selected-date'
          onClick={toggle}
        >{`${selectedStartDate.toLocaleDateString()} - ${selectedEndDate.toLocaleDateString()}`}</label>
      </div>
      <FontAwesomeIcon
        icon={isOpen ? faAngleUp : faAngleDown}
        onClick={toggle}
      />
    </div>
  );

  return (
    <div className='date-range-field week-picker'>
      <NavigationButton
        onClick={() => {
          void onClickPrevious();
        }}
        disabled={!canClickPrevious}
        left
      />
      <div>
        <ReactDatePicker
          minDate={minDate}
          maxDate={maxDate}
          selected={selectedStartDate}
          onChange={(date) => {
            void onChange(date);
          }}
          open={isOpen}
          customInput={renderLabel()}
          onBlur={toggle}
          onClickOutside={toggle}
          calendarStartDay={1}
          disabledKeyboardNavigation
        />
      </div>
      <NavigationButton
        onClick={() => {
          void onClickNext();
        }}
        disabled={!canClickNext}
      />
    </div>
  );
});
